import React, { useCallback, useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardText,
  CCol,
  CContainer,
  CImage,
  CRow,
  CAlert,
  CBadge,
  CFormInput,
  CFormLabel,
} from '@coreui/react'
import { cilXCircle, cilSave, cilChevronRight, cilLightbulb } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import apiClient from '../../services/apiClient'
import { useNavigate } from 'react-router-dom'
import { isNull } from 'lodash'
import { buildApiUrl } from '../../utils/getConfiguration'
import InternalAppHeader from './components/InternalAppHeader'
import { useTranslation } from 'react-i18next'
import { SplashScreen } from '@capacitor/splash-screen'

const SuppliersInnoList = () => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [visible1, setVisible1] = useState(false)
  const [suppliers, setSuppliers] = useState([])
  const [ideaDescriptions, setIdeaDescriptions] = useState({}) // změna názvu a struktury stavu

  const fetchSuppliersData = async () => {
    try {
      const grp_ID = localStorage.getItem('grp_ID')
      const response = await apiClient.get(buildApiUrl('suppliers', { grp_ID }))
      setSuppliers(response.data)
    } catch (error) {
      console.error('Error fetching suppliers', error)
    }
  }

  useEffect(() => {
    fetchSuppliersData()
  }, [])

  const [prefsuppliers, setPrefSuppliers] = useState([])

  const fetchPrefSuppliersData = async () => {
    try {
      const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      const grp_ID = localStorage.getItem('grp_ID')
      const params = { reminder_ID, account_ID, grp_ID }
      console.log('Preferred supplier params', params)
      const response = await apiClient.get(buildApiUrl('supplierPref', params))
      setPrefSuppliers(response.data)
    } catch (error) {
      console.error('Error fetching supplier', error)
    }
  }

  useEffect(() => {
    if (
      String(localStorage.getItem('supplierid')) === 'null' &&
      String(localStorage.getItem('suppliertel')) === 'null'
    ) {
      console.log('Needed supplier')
      setVisible(true)
    } else {
      console.log('Not needed supplier')
      setVisible(false)
    }
    console.log(localStorage.getItem('suppliertel'))
    fetchPrefSuppliersData()
  }, [])

  const [startups, setStartups] = useState([])

  const fetchInnovationsData = async () => {
    try {
      const account_ID = localStorage.getItem('account_ID')
      const response = await apiClient.get(buildApiUrl('startupsList', { account_ID }))
      setStartups(response.data)

      // Inicializace hodnot pro každý startup
      const initialIdeas = {}
      response.data.forEach((startup) => {
        initialIdeas[startup.startup_id] = Array.isArray(startup.idea)
          ? startup.idea[0] || ''
          : startup.idea || ''
      })
      setIdeaDescriptions(initialIdeas)
    } catch (error) {
      console.error('Error fetching suppliers', error)
    }
  }

  const hideSplashScreen = useCallback(() => {
    if (typeof window === 'undefined') {
      return
    }

    const splash = document.getElementById('splash-screen')
    if (splash) {
      splash.style.display = 'none'
    }

    if (typeof SplashScreen?.hide === 'function') {
      SplashScreen.hide({ fadeOutDuration: 200 }).catch((error) => {
        console.warn('Unable to hide splash screen in SuppliersInnoList', error)
      })
    } else if (typeof window.SplashScreen?.hide === 'function') {
      window.SplashScreen.hide({ fadeOutDuration: 200 }).catch((error) => {
        console.warn('Unable to hide splash screen in SuppliersInnoList', error)
      })
    }
  }, [])

  useEffect(() => {
    hideSplashScreen()
  }, [hideSplashScreen])

  useEffect(() => {
    fetchInnovationsData().finally(hideSplashScreen)
  }, [hideSplashScreen])

  let navigate = useNavigate()

  const handleClickUnassign = async (startup_ID) => {
    try {
      console.log('Account_ID ' + localStorage.getItem('account_ID'))
      //console.log('Reminder_ID ' + localStorage.getItem('taskid'))
      //const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      await apiClient.get(
        buildApiUrl('startupUnassign', {
          startup_ID,
          account_ID,
        }),
      )
      //localStorage.setItem('supplierid', 'null')
      //localStorage.setItem('suppliertel', 'null')
      fetchInnovationsData()
      setVisible(true)
      console.log('Unassigned startup ' + startup_ID)
      //localStorage.removeItem('supplierid')
      //window.history.back()
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleClickSave = async (startup_ID, type, idea) => {
    try {
      console.log('Account_ID ' + localStorage.getItem('account_ID'))
      //console.log('Reminder_ID ' + localStorage.getItem('taskid'))
      //console.log('Supplier_ID ' + localStorage.getItem('supplierid'))

      //const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      //const supplier_ID = localStorage.getItem('supplierid')
      //const supplier_name = name
      //const supplier_contact_name = contact
      //const supplier_contact_tel = tel
      await apiClient.get(
        buildApiUrl('startupIdeaSave', {
          account_ID,
          startup_ID,
          type,
          idea,
        }),
      )
      // Example: buildApiUrl('startupAssign', { account_ID: 3, startup_ID: 1, idea: 'Test' })
      fetchInnovationsData()
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  function mergeTel(str1) {
    return 'tel:' + str1
  }

  function getIdeaTypeLabel(type) {
    switch (type) {
      case 'F':
        return t('suppliersInno.types.F')
      case 'C':
        return t('suppliersInno.types.C')
      case 'J':
        return t('suppliersInno.types.J')
      case isNull(type):
        return ''
      default:
        return ''
    }
  }

  return (
    <div className="buying-list-wrapper min-vh-100 d-flex flex-column">
      <CContainer className="py-4 flex-grow-1">
        <InternalAppHeader
          title={t('suppliersInnoList.headerTitle')}
          onBack={() => window.history.back()}
        />
        <CRow className="justify-content-center g-0 mt-2">
          <CCol lg={10}>
            <CCard className="mb-0 border-0 shadow-sm">
              <CCardBody>
                <div className="d-flex justify-content-end align-items-center">
                  <CButton
                    color="primary"
                    className="suppliers-inno__next-btn"
                    onClick={() => {
                      console.log('Selected startup list')
                      navigate('/suppliersinnoproject')
                    }}
                    aria-label={t('suppliersInnoList.actions.goStatus')}
                  >
                    <CIcon icon={cilChevronRight} />
                  </CButton>
                </div>
                <h4 id="traffic" className="card-title mb-0">
                  {t('suppliersInnoList.sections.listTitle')}
                </h4>
                <hr />
                {startups.length > 0 ? (
                  <CRow className="gy-3">
                    {startups.map((startup) => {
                      const ideaTypeLabel = getIdeaTypeLabel(startup.type)
                      const description =
                        typeof startup.description === 'string' && startup.description.length > 0
                          ? startup.description.substring(0, 120) +
                            (startup.description.length > 120 ? '...' : '')
                          : ''
                      const linkTarget =
                        startup.link && /^https?:\/\//i.test(startup.link)
                          ? startup.link
                          : startup.link
                            ? `https://${startup.link}`
                            : null

                      const ideaTitle =
                        typeof startup.idea === 'string' && startup.idea.trim().length > 0
                          ? startup.idea.trim()
                          : typeof startup.company === 'string' &&
                              startup.company?.trim().length > 0
                            ? startup.company.trim()
                            : t('suppliersInno.labels.startupFallback', { id: startup.startup_id })
                      const pictureSrc = startup.pic
                        ? `https://www.emerkur.eu/startups/${startup.pic}`
                        : null

                      return (
                        <CCol xs={12} key={startup.startup_id}>
                          <CCard className="innovation-startup-card h-100 border-0">
                            <CCardBody className="d-flex flex-column gap-4">
                              <div className="d-flex flex-wrap gap-3 align-items-start">
                                <div className="innovation-startup-card__logo">
                                  {pictureSrc ? (
                                    <CImage
                                      rounded
                                      src={pictureSrc}
                                      alt={`${ideaTitle} logo`}
                                      className="w-100 h-100 object-fit-contain"
                                    />
                                  ) : (
                                    <div className="innovation-startup-card__logo-placeholder">
                                      <CIcon icon={cilLightbulb} size="lg" />
                                    </div>
                                  )}
                                </div>
                                <div className="flex-grow-1 d-flex flex-column gap-2">
                                  <div className="d-flex flex-wrap align-items-center gap-2 justify-content-between">
                                    <h5 className="mb-0 innovation-startup-card__title">
                                      {ideaTitle}
                                    </h5>
                                    {ideaTypeLabel ? (
                                      <CBadge color="info" className="text-uppercase fw-semibold">
                                        {ideaTypeLabel}
                                      </CBadge>
                                    ) : (
                                      <CBadge
                                        color="secondary"
                                        className="text-uppercase bg-secondary-subtle text-secondary fw-semibold"
                                      >
                                        {t('suppliersInnoList.labels.typeUndefined')}
                                      </CBadge>
                                    )}
                                  </div>
                                  {description && (
                                    <CCardText className="mb-0 text-medium-emphasis">
                                      {description}
                                    </CCardText>
                                  )}
                                  {linkTarget && (
                                    <a
                                      href={linkTarget}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="innovation-startup-card__link"
                                      onClick={(e) => {
                                        window.open(linkTarget, '_blank', 'noopener,noreferrer')
                                        e.preventDefault()
                                      }}
                                    >
                                      {startup.link}
                                    </a>
                                  )}
                                </div>
                              </div>
                              <div className="innovation-startup-card__controls">
                                <div className="flex-grow-1">
                                  <CFormLabel
                                    htmlFor={`ideaShortDescription-${startup.startup_id}`}
                                    className="innovation-startup-card__label"
                                  >
                                    {t('suppliersInnoList.labels.ideaLabel')}
                                  </CFormLabel>
                                  <CFormInput
                                    id={`ideaShortDescription-${startup.startup_id}`}
                                    type="text"
                                    placeholder={t('suppliersInnoList.labels.ideaPlaceholder')}
                                    aria-label={t('suppliersInnoList.labels.ideaAria')}
                                    value={ideaDescriptions[startup.startup_id] || ''}
                                    className="innovation-startup-card__input"
                                    onChange={(e) =>
                                      setIdeaDescriptions({
                                        ...ideaDescriptions,
                                        [startup.startup_id]: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                                <div className="d-flex gap-2 flex-wrap justify-content-end">
                                  <CButton
                                    color="success"
                                    title={t('suppliersInnoList.actions.saveIdea')}
                                    aria-label={t('suppliersInnoList.actions.saveIdea')}
                                    onClick={() => {
                                      console.log('Save idea for startup Nr.' + startup.startup_id)
                                      handleClickSave(
                                        startup.startup_id,
                                        startup.type,
                                        ideaDescriptions[startup.startup_id] || '',
                                      )
                                    }}
                                  >
                                    <CIcon icon={cilSave} size="lg" />
                                  </CButton>
                                  <CButton
                                    color="danger"
                                    title={t('suppliersInnoList.actions.remove')}
                                    aria-label={t('suppliersInnoList.actions.remove')}
                                    onClick={() => {
                                      console.log(
                                        'Delete from selection startup Nr.' + startup.startup_id,
                                      )
                                      handleClickUnassign(startup.startup_id)
                                    }}
                                  >
                                    <CIcon icon={cilXCircle} size="lg" />
                                  </CButton>
                                </div>
                              </div>
                            </CCardBody>
                          </CCard>
                        </CCol>
                      )
                    })}
                  </CRow>
                ) : (
                  <CAlert color="info" className="mb-0">
                    {t('suppliersInnoList.messages.loading')}
                  </CAlert>
                )}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default SuppliersInnoList
